import React, { useContext, useMemo } from "react";
import { Button } from "./Button";
import { AppContext } from "../context/AppContext";
import { truncateEthAddress } from "../utils/string";

export interface Props {}

export default function Header(props: Props) {
  const { account, connectWallet } = useContext(AppContext);

  const renderConnect = useMemo(() => {
    if (account) {
      return (
        <p className="text-white text-sm md:text-base">
          {truncateEthAddress(account)}
        </p>
      );
    }
    return (
      <Button
        className="rounded-full bg-gradient-to-r from-[#FD7155] to-[#6B94BC] px-3 py-2 text-sm text-white"
        onClick={connectWallet}
        text="Connect"
      />
    );
  }, [account, connectWallet]);

  return (
    <div className="flex sticky top-0 py-3 px-5 justify-between items-center">
      <p
        className="md:text-xl text-white"
        style={{ fontFamily: "Audiowide, ui-sans-serif" }}
      >
        EMETH Portable
      </p>
      {renderConnect}
    </div>
  );
}
